<template>
  <div class="section-type-c pt-5 pb-5" style="background: white;">
    <div class="personal-container">
      <div class="row section-type-c bground-config-clean " :style="{ backgroundImage: `url('${backgroundImg}')` }">
        <div class="col-12 vertical-align advertisements">
          <div class="p-2">
            <h1 class="text-light text-center">El auto de tu sueños está a pocos clics</h1>
            <h2 class="text-light text-center">¡Comienza ahora! Uno de nuestros ejecutivos <br> se pondrá en contacto contigo</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DreamCar',
  data () {
    return {
      backgroundImg: require('@/assets/images/2021-Chevrolet-Blazer-008.jpg')
    }
  }
}
</script>

<style scoped>

</style>
